module.exports = __webpack_public_path__ + "static/media/banner-gradient.9907a1a2.svg";